import { render } from "./ActionsAttachmentPeriod.vue?vue&type=template&id=2d7f99c4&scoped=true"
import script from "./ActionsAttachmentPeriod.vue?vue&type=script&lang=js"
export * from "./ActionsAttachmentPeriod.vue?vue&type=script&lang=js"

import "./ActionsAttachmentPeriod.vue?vue&type=style&index=0&id=2d7f99c4&lang=scss&scoped=true"
import "./ActionsAttachmentPeriod.vue?vue&type=style&index=1&id=2d7f99c4&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7f99c4"]])

export default __exports__